import { z } from 'zod/v4';

export const fleetCloudProviderSchema = z.preprocess(
  (value) =>
    value !== null &&
    typeof value !== 'undefined' &&
    /^MicrosoftAzure$/i.test(String(value))
      ? 'Azure'
      : 'AWS',
  z.union([z.literal('AWS'), z.literal('Azure')])
);

export type FleetCloudProvider = z.infer<typeof fleetCloudProviderSchema>;
